import {
  FETCH_LIFETIME_REQUEST,
  FETCH_LIFETIME_SUCCESS,
  FETCH_LIFETIME_FAILURE,
  UPLOAD_EMAIL_REQUEST,
  UPLOAD_EMAIL_SUCCESS,
  UPLOAD_EMAIL_FAILURE,
  SEARCH_LIFETIME_REQUEST,
  SEARCH_LIFETIME_SUCCESS,
  SEARCH_LIFETIME_FAILURE,
} from './lifeTimeAction';

const initialState = {
  loading: false,
  lifeTimeData: [],
  searchResults: [],
  error: '',
};

const lifeTimeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIFETIME_REQUEST:
    case UPLOAD_EMAIL_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case FETCH_LIFETIME_SUCCESS:
      return {
        loading: false,
        lifeTimeData: [...state.lifeTimeData, ...action.payload],
        error: '',
      };
    case FETCH_LIFETIME_FAILURE:
      return {
        loading: false,
        lifeTimeData: [],
        error: action.payload,
      };
    case UPLOAD_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
      };
    case UPLOAD_EMAIL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case SEARCH_LIFETIME_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case SEARCH_LIFETIME_SUCCESS:
      return {
        ...state,
        loading: false,
        searchResults: action.payload,
        error: '',
      };
    case SEARCH_LIFETIME_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default lifeTimeReducer;
